import './App.scss';
import Wrapper from './components/Wrapper';

function App() {
	return (
		<div className='App'>
			<Wrapper />
			<div className="attribution">
				Challenge by <a href="https://www.frontendmentor.io?ref=challenge" target="_blank" rel="noreferrer">Frontend Mentor</a>. 
				Coded by <a href="https://nicoleyj.dev/">Nicole Yang</a>.
			</div>
		</div>
	);
}

export default App;
